module.exports = __webpack_public_path__ + "img/anjing_Nocalcu.a20e0a61.svg";